"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _hooks = require("../../../hooks");

var _components = require("../../../components");

var _LocationCardModule = _interopRequireDefault(require("./LocationCard.module.scss"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LocationCardType6 = function LocationCardType6(_ref) {
  var _orderTypeHours, _orderTypeHours$hours;

  var address = _ref.address,
      cellType = _ref.cellType,
      dataTest = _ref.dataTest,
      diningOption = _ref.diningOption,
      idx = _ref.idx,
      innerRef = _ref.innerRef,
      isOpen = _ref.isOpen,
      name = _ref.name,
      orderButtonCopy = _ref.orderButtonCopy,
      orderTypeHours = _ref.orderTypeHours,
      onEnterMenu = _ref.onEnterMenu,
      restaurantGroups = _ref.restaurantGroups;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      buttons = _useTemplate$useCell.buttons,
      views = _useTemplate$useCell.views,
      labelTextStyles = _useTemplate$useCell.labelTextStyles;

  var dayOfWeek = new Date().getDay();
  var diningOptionHours = (_orderTypeHours = orderTypeHours(diningOption)) === null || _orderTypeHours === void 0 ? void 0 : (_orderTypeHours$hours = _orderTypeHours.hours) === null || _orderTypeHours$hours === void 0 ? void 0 : _orderTypeHours$hours.find(function (hour) {
    return hour.days.includes(dayOfWeek);
  });
  var openingHoursText = (0, _utils.getOpeningHoursText)(diningOptionHours);
  return /*#__PURE__*/_react["default"].createElement(_components.View, {
    Component: "li",
    className: [_LocationCardModule["default"].locationCard, "location-card"],
    innerRef: innerRef,
    dataTest: dataTest,
    type: views.background,
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_components.View, {
    className: _LocationCardModule["default"]["locationCard-top"],
    type: views.primary,
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_components.Box, {
    className: _LocationCardModule["default"]["locationCard-top-header"],
    justify: "between"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    role: "heading",
    "aria-level": "3",
    "aria-label": name,
    className: _LocationCardModule["default"].title,
    type: labelTextStyles.primary
  }, name), /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    className: _LocationCardModule["default"]["locationCard-button"],
    type: buttons.primary,
    onClick: onEnterMenu,
    disabled: !isOpen,
    dataTest: "location-card-order-button-".concat(idx + 1)
  }, orderButtonCopy)), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary,
    className: _LocationCardModule["default"]["locationCard-top-address"]
  }, "".concat(address[0], " ").concat(address[1])), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary,
    className: _LocationCardModule["default"]["locationCard-top-address"]
  }, openingHoursText)), /*#__PURE__*/_react["default"].createElement(_components.View, {
    className: _LocationCardModule["default"]["locationCard-bottom"],
    type: views.secondary,
    direction: "column",
    justify: "between"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    className: _LocationCardModule["default"]["locationCard-bottom-title"],
    type: labelTextStyles.tertiary
  }, "Restaurants"), /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.secondary,
    className: _LocationCardModule["default"]["locationCard-bottom-icon"]
  }, restaurantGroups.map(function (restaurantGroup) {
    return /*#__PURE__*/_react["default"].createElement("img", {
      key: restaurantGroup.id,
      className: _LocationCardModule["default"]["locationCard-bottom-icon-content"],
      src: restaurantGroup.media.restaurantIcon
    });
  }))));
};

var _default = /*#__PURE__*/_react["default"].memo(LocationCardType6);

exports["default"] = _default;